import { alpha, Box, Stack, Theme, useTheme } from "@mui/material";
import FormCheckInNewVisitor from "components/Check-in/FormCheckInNewVisitor/FormCheckInNewVisitor";
import FormCheckInReturnVistor from "components/Check-in/FormCheckInReturnVistor";
import VerticalTabs from "components/Check-in/VerticalTabs";
import CheckInQrCode from "components/CheckInQrCode";

const CheckIn = () => {
  const theme: Theme = useTheme();

  return (
    <Box
      width="100%"
      maxWidth={1000}
      margin="0 auto"
      borderRadius={3}
      overflow="hidden"
      marginTop={6}
      bgcolor={alpha(theme.palette.common.black, 0.3)}
    >
      <Stack direction="row">
        <VerticalTabs
          items={[<FormCheckInNewVisitor />, <FormCheckInReturnVistor />]}
        />
        <Box flex="1 0 304px" display={{ xs: "none", md: "block" }}>
          <CheckInQrCode />
        </Box>
      </Stack>
    </Box>
  );
};

export default CheckIn;
